export default __webpack_public_path__ + "static/media/IBMAddComment.1652472e.svg";